let initialMinecraftHandoffTicket: string | null | undefined

export function takeMinecraftHandoffFragment(): string | null {
  const fragment = window.location.hash
  if (!fragment.startsWith('#handoff=')) return null
  // A fragment never reaches the server, and removing it before the first network
  // request keeps a one-use ticket out of address-bar history and referrer paths.
  window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`)
  const values = new URLSearchParams(fragment.slice(1)).getAll('handoff')
  return values.length === 1 ? values[0] : null
}

export function takeInitialMinecraftHandoffFragment(): string | null {
  if (initialMinecraftHandoffTicket === undefined) {
    initialMinecraftHandoffTicket = takeMinecraftHandoffFragment()
  }
  return initialMinecraftHandoffTicket
}
